module.exports = __webpack_public_path__ + "img/supply-chain.cfb2e073.png";